var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.isLoading)?_c('global-loader'):_vm._e(),_c('global-alert'),_c('global-tip'),_c('global-modal-container')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }